import { createContext } from 'react';
import type { UseAuthResult } from './types';

export const AuthContext = createContext<UseAuthResult | null>(null);

export const authBypassClerkEnabled = import.meta.env.VITE_AUTH_BYPASS_CLERK === 'true';
